module.exports = __webpack_public_path__ + "media/images/tmp/slide1-c4ddacadd2cab45319ab7bce9f62617b.jpg";